import React from 'react';
import { Label } from './ui/label';
import { FileDropzone } from './FileDropzone';

/**
 * Documents Registration Verification block for the HOME registration form.
 * Renders a Malaysian/Non-Malaysian radio toggle and the corresponding upload
 * dropzones for IC + Utility Bill (Malaysian) or Passport (Non-Malaysian),
 * plus the upfront-payment disclaimer.
 */
export const HomeDocsSection = ({ nationality, setNationality, docs, setDocs }) => {
  return (
    <div className="rounded-xl border border-gray-200 p-5 bg-gray-50/50 space-y-5">
      <div>
        <p className="text-base font-semibold text-gray-900">
          Documents Registration Verification Require <span className="text-red-500">*</span>
        </p>
      </div>

      <div className="flex flex-col gap-2">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name="nationality"
            value="malaysian"
            checked={nationality === 'malaysian'}
            onChange={() => setNationality('malaysian')}
            className="w-4 h-4 accent-[#FF6600]"
            data-testid="nationality-malaysian"
          />
          <span className="text-sm text-gray-800">Malaysian</span>
        </label>
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name="nationality"
            value="non-malaysian"
            checked={nationality === 'non-malaysian'}
            onChange={() => setNationality('non-malaysian')}
            className="w-4 h-4 accent-[#FF6600]"
            data-testid="nationality-non-malaysian"
          />
          <span className="text-sm text-gray-800">Non Malaysian</span>
        </label>
      </div>

      {nationality === 'malaysian' && (
        <div className="space-y-5">
          <div className="space-y-2">
            <Label>Upload MyKad IC Front for Registration Verification Purpose</Label>
            <p className="text-xs text-gray-500 -mt-1">MyKad must be scanned or photo in colour, not in black and white</p>
            <FileDropzone id="ic-front" value={docs.icFront} onChange={(f) => setDocs(prev => ({ ...prev, icFront: f }))} />
          </div>
          <div className="space-y-2">
            <Label>Upload MyKad IC Back for Verification Purpose</Label>
            <p className="text-xs text-gray-500 -mt-1">MyKad must be scanned or photo in colour, not in black and white</p>
            <FileDropzone id="ic-back" value={docs.icBack} onChange={(f) => setDocs(prev => ({ ...prev, icBack: f }))} />
          </div>
          <div className="space-y-2">
            <Label>Installation Address Utility Bill</Label>
            <p className="text-xs text-gray-500 -mt-1">Electricity Bill or Water Bill — any bill that matches your intended installation address</p>
            <FileDropzone id="utility-bill" value={docs.utilityBill} onChange={(f) => setDocs(prev => ({ ...prev, utilityBill: f }))} />
          </div>
          <div className="text-xs text-gray-600 bg-white border border-gray-200 rounded-md p-3 leading-relaxed">
            Malaysian customer need to pay <strong>RM100 upfront payment</strong> within ten (10) days effective from date of Service Activation. The amount will be credited into your account. Depending on your billing cycle, the amount will be reflected in your first or second bill. TM reserves the right to terminate the account in the event of non-payment as per required above.
          </div>
        </div>
      )}

      {nationality === 'non-malaysian' && (
        <div className="space-y-5">
          <div className="space-y-2">
            <Label>Upload Passport for Registration Verification Purpose</Label>
            <FileDropzone id="passport" value={docs.passport} onChange={(f) => setDocs(prev => ({ ...prev, passport: f }))} />
          </div>
          <div className="text-xs text-gray-600 bg-white border border-gray-200 rounded-md p-3 leading-relaxed">
            Foreigner customer need to pay <strong>RM500 upfront payment</strong> within ten (10) days effective from date of Service Activation. The amount will be credited into your account. Depending on your billing cycle, the amount will be reflected in your first or second bill. TM reserves the right to terminate the account in the event of non-payment as per required above.
          </div>
        </div>
      )}
    </div>
  );
};
